import React from 'react'
import SVG from '../../components/SVG'

const IconMenu = (props) => {
  return (
    <SVG viewBox="0 0 35 35" {...props}>
      <g>
        <g>
          <line x1="9.27" y1="8" x2="33.49" y2="8" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.29" />
          <line x1="9.27" y1="17.5" x2="33.49" y2="17.5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.29" />
          <line x1="9.27" y1="27.42" x2="33.49" y2="27.42" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.29" />
        </g>
        <circle cx="2.76" cy="7.98" r="2.4" fill="currentColor" />
        <circle cx="2.76" cy="17.5" r="2.4" fill="currentColor" />
        <circle cx="2.76" cy="27.02" r="2.4" fill="currentColor" />
      </g>
    </SVG>
  )
}

export default IconMenu
